// Możesz umieścić ten kod w osobnym pliku np. analytics.js i zaimportować go 
// w głównym pliku, lub wkleić bezpośrednio do głównego pliku JS.

const analyticsInitializer = {
    gaLoaded: false,         // Flaga: czy GA już załadowano?
    listenersAttached: false, // Flaga: czy już podpięto nasłuchiwacze?

    // Funkcja, która fizycznie tworzy i dodaje skrypty GA
    _loadGoogleAnalyticsScripts(gaCode, gaCodeAllAccounts) {
        if (this.gaLoaded) return; // Już załadowane, nic nie rób
        this.gaLoaded = true;

        console.log(`[Analytics] Ładowanie GA. ID Główny: ${gaCode}, ID Dodatkowy: ${gaCodeAllAccounts || 'brak'}`);

        // 1. Skrypt zewnętrzny gtag.js
        const scriptGtag = document.createElement('script');
        scriptGtag.src = `https://www.googletagmanager.com/gtag/js?id=${gaCode}`;
        scriptGtag.async = true;
        scriptGtag.onerror = () => { // Obsługa błędu ładowania
            console.error('[Analytics] Błąd ładowania skryptu gtag.js');
            this.gaLoaded = false; // Można zresetować flagę, aby umożliwić ponowną próbę?
        };
        document.head.appendChild(scriptGtag);

        // 2. Skrypt konfiguracyjny inline
        const scriptConfig = document.createElement('script');
        let configScriptContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaCode}'); 
    `;
        // Dodaj drugi config tylko jeśli istnieje i nie jest pusty
        if (gaCodeAllAccounts && gaCodeAllAccounts !== '') {
            configScriptContent += `\ngtag('config', '${gaCodeAllAccounts}');`;
        }
        scriptConfig.innerHTML = configScriptContent;
        document.head.appendChild(scriptConfig); // Dodaj do head

        console.log('[Analytics] Skrypty GA dodane do DOM.');
    },

    // Funkcja, która ustawia "czekanie" na interakcję użytkownika
    initLazyLoad(config) {
        // Sprawdź podstawową konfigurację
        if (!config || !config.gaCode) {
            console.error('[Analytics] Brak głównego kodu GA w konfiguracji!');
            return;
        }

        // Nie inicjuj ponownie, jeśli już działają listenery lub GA jest załadowane
        if (this.listenersAttached || this.gaLoaded) {
            console.log('[Analytics] Inicjalizacja już wykonana lub GA załadowane.');
            return;
        }

        const gaCode = config.gaCode;
        const gaCodeAll = config.gaCodeAll || null;

        console.log('[Analytics] Ustawianie nasłuchiwania na interakcję użytkownika...');

        // Funkcja wywoływana przy pierwszej interakcji
        const triggerLoad = () => {
            // Wywołaj ładowanie skryptów, zachowując 'this' jako analyticsInitializer
            this._loadGoogleAnalyticsScripts.call(this, gaCode, gaCodeAll);
            // Listenery same się usuną dzięki 'once: true'
        };

        // Dodaj nasłuchiwanie na różne typy interakcji.
        // 'once: true' oznacza, że listener uruchomi się tylko raz i sam usunie.
        window.addEventListener('scroll', triggerLoad, { passive: true, once: true });
        window.addEventListener('mousemove', triggerLoad, { passive: true, once: true });
        window.addEventListener('touchstart', triggerLoad, { passive: true, once: true });
        window.addEventListener('click', triggerLoad, { passive: true, once: true });

        this.listenersAttached = true; // Zaznacz, że listenery zostały dodane
    }
};

// Jeśli używasz systemu modułów (np. Webpack, Rollup), wyeksportuj:
// export default analyticsInitializer; 
// lub export { analyticsInitializer };

// Jeśli NIE używasz modułów i chcesz, aby było globalnie dostępne (mniej zalecane):
window.analyticsInitializer = analyticsInitializer;